import React, { useState } from 'react';

// Helper: Convert manufacturer name to logo path
function getLogoPath(manufacturer) {
  const filename = manufacturer.toLowerCase().replace(/\s+/g, '_');
  return `/logos/${filename}_full_logo.svg`;
}

// Reusable manufacturer logo component
function ManufacturerLogo({ manufacturer, logoPath }) {
  const [logoError, setLogoError] = useState(false);
  const finalLogoPath = logoPath || getLogoPath(manufacturer);

  return (
    <div className="manufacturer-logo-item">
      {logoError ? (
        <div className="manufacturer-logo-placeholder">
          <span className="logo-text">{manufacturer}</span>
        </div>
      ) : (
        <img
          src={finalLogoPath}
          alt={`${manufacturer} logo`}
          className="manufacturer-logo"
          onError={() => setLogoError(true)}
        />
      )}
    </div>
  );
}

function ManufacturerCard({ manufacturer, firstFlight, unitBuilt, cost, manufacturers }) {
  // Support both single manufacturer (legacy) and multiple manufacturers
  const manufacturerList = manufacturers || [{ name: manufacturer, logoPath: getLogoPath(manufacturer) }];
  const manufacturerNames = manufacturerList.map(m => m.name).join(' & ');

  return (
    <div className="manufacturer-card">
      <div className={`manufacturer-logo-container ${manufacturerList.length > 1 ? 'manufacturer-logo-container-multi' : ''}`}>
        {manufacturerList.map((mfr, index) => (
          <ManufacturerLogo key={index} manufacturer={mfr.name} logoPath={mfr.logoPath} />
        ))}
      </div>

      <div className="manufacturer-stats">
        <div className="stat-item">
          <span className="stat-label">Manufacturer{manufacturerList.length > 1 ? 's' : ''}</span>
          <span className="stat-value">{manufacturerNames}</span>
        </div>

        {firstFlight && (
          <div className="stat-item">
            <span className="stat-label">First Flight</span>
            <span className="stat-value">{firstFlight}</span>
          </div>
        )}

        {unitBuilt && (
          <div className="stat-item">
            <span className="stat-label">Units Built</span>
            <span className="stat-value">{unitBuilt}</span>
          </div>
        )}

        {cost && (
          <div className="stat-item">
            <span className="stat-label">Unit Cost</span>
            <span className="stat-value">{cost}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ManufacturerCard;
